export const LARGE_SHADOW = "0px 0px 40px rgba(70, 70, 70, 0.1)";
